// import { readFileSync } from "fs";
import { useEffect } from "react";
import text from "../Constants/songs.json";
// import { FunQuestionnaire } from "./FunQuestionnaire";

interface KnowTheSongsProps { 
	songs: Song[];
	// this is a setState function
	setSongs: React.Dispatch<React.SetStateAction<Song[]>>;
}
interface Song {
	name: string;
	lyrics: string;
}

const KnowTheSongs: React.FC<KnowTheSongsProps> = ({songs, setSongs}) => {

	// const [songs, setSongs] = useState<Song[]>([]);
	// useEffect(() => {
	// 	console.log(songs);
	// });

	useEffect(() => {
		const filteredSongs = Object.entries(text).filter(([_, value]) => value !== "").map(([key, value]) => ({
			name: key,
			lyrics: value,
		}));
		setSongs(filteredSongs);
	}, [setSongs]);

	return null;
	// if (!songs) return null;
	// return (
	// 	<FunQuestionnaire songs={songs} />
	// );
};

export default KnowTheSongs;